export default function Features() {
  return (
    <>
      <section id="features" className="sec">
        <div className="shell">
          <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-end', justifyContent: 'space-between', gap: '40px' }}>
            <div style={{ maxWidth: '700px' }}>
              <p className="eyebrow">The platform</p>
              <h2 className="h-lg" style={{ marginTop: '18px' }}>Everything You Need<br />to Run the Game.</h2>
            </div>
            <p className="lead" style={{ maxWidth: '420px' }}>
              Courts, coaches, members, money. PlaySlot replaces the spreadsheets, the phone bookings and the four disconnected tools with one system your whole club works in.
            </p>
          </div>

          <div className="grid-4 reveal" style={{ marginTop: '64px' }}>

            <article className="card">
              <span className="card-num">01</span>
              <h3>Reservations</h3>
              <p>Let players book courts in seconds.</p>
              <div className="viz">
                <div style={{ position: 'absolute', inset: '14px', display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gridTemplateRows: 'repeat(4, 1fr)', gap: '5px' }}>
                  <span style={{ borderRadius: '3px', background: 'rgba(255,255,255,.06)' }}></span><span style={{ borderRadius: '3px', background: 'rgba(200,255,60,.85)' }}></span><span style={{ borderRadius: '3px', background: 'rgba(255,255,255,.06)' }}></span><span style={{ borderRadius: '3px', background: 'rgba(255,255,255,.06)' }}></span><span style={{ borderRadius: '3px', background: 'rgba(76,125,255,.55)' }}></span>
                  <span style={{ borderRadius: '3px', background: 'rgba(255,255,255,.06)' }}></span><span style={{ borderRadius: '3px', background: 'rgba(255,255,255,.06)' }}></span><span style={{ borderRadius: '3px', background: 'rgba(200,255,60,.85)' }}></span><span style={{ borderRadius: '3px', background: 'rgba(255,255,255,.06)' }}></span><span style={{ borderRadius: '3px', background: 'rgba(255,255,255,.06)' }}></span>
                  <span style={{ borderRadius: '3px', background: 'rgba(76,125,255,.55)' }}></span><span style={{ borderRadius: '3px', background: 'rgba(255,255,255,.06)' }}></span><span style={{ borderRadius: '3px', background: 'rgba(255,255,255,.06)' }}></span><span style={{ borderRadius: '3px', background: 'rgba(200,255,60,.85)' }}></span><span style={{ borderRadius: '3px', background: 'rgba(255,255,255,.06)' }}></span>
                  <span style={{ borderRadius: '3px', background: 'rgba(255,255,255,.06)' }}></span><span style={{ borderRadius: '3px', background: 'rgba(255,255,255,.06)' }}></span><span style={{ borderRadius: '3px', background: 'rgba(255,255,255,.06)' }}></span><span style={{ borderRadius: '3px', background: 'rgba(76,125,255,.55)' }}></span><span style={{ borderRadius: '3px', background: 'rgba(255,255,255,.06)' }}></span>
                </div>
              </div>
            </article>

            <article className="card">
              <span className="card-num">02</span>
              <h3>Events</h3>
              <p>Run tournaments, leagues, classes and events effortlessly.</p>
              <div className="viz">
                <svg width="100%" height="100%" viewBox="0 0 240 148" fill="none" aria-hidden="true">
                  <g stroke="rgba(255,255,255,.16)" strokeWidth="1.4">
                    <path d="M26 26h34v22h34"></path><path d="M26 66h34V44"></path><path d="M26 102h34v20h34"></path><path d="M26 138h34v-16"></path><path d="M94 48v37h38"></path><path d="M94 122V85"></path>
                  </g>
                  <g fill="rgba(255,255,255,.08)">
                    <rect x="12" y="19" width="30" height="12" rx="3"></rect><rect x="12" y="59" width="30" height="12" rx="3"></rect><rect x="12" y="95" width="30" height="12" rx="3"></rect><rect x="12" y="131" width="30" height="12" rx="3"></rect>
                  </g>
                  <rect x="120" y="76" width="42" height="16" rx="4" fill="rgba(200,255,60,.85)"></rect>
                  <text x="141" y="88" textAnchor="middle" fontFamily="Archivo, sans-serif" fontSize="9" fontWeight="700" fill="#070809">FINAL</text>
                </svg>
              </div>
            </article>

            <article className="card">
              <span className="card-num">03</span>
              <h3>Coach Connect</h3>
              <p>Connect players with coaches and training opportunities.</p>
              <div className="viz">
                <svg width="100%" height="100%" viewBox="0 0 240 148" fill="none" aria-hidden="true">
                  <path className="dash" d="M74 74h92" stroke="#C8FF3C" strokeWidth="1.6"></path>
                  <circle cx="62" cy="74" r="22" fill="#0E1113" stroke="rgba(255,255,255,.18)" strokeWidth="1.4"></circle>
                  <circle cx="62" cy="68" r="7" fill="rgba(255,255,255,.3)"></circle>
                  <path d="M50 88c2-7 6-10 12-10s10 3 12 10" fill="rgba(255,255,255,.22)"></path>
                  <circle cx="178" cy="74" r="22" fill="#0E1113" stroke="rgba(200,255,60,.5)" strokeWidth="1.4"></circle>
                  <circle cx="178" cy="68" r="7" fill="rgba(200,255,60,.75)"></circle>
                  <path d="M166 88c2-7 6-10 12-10s10 3 12 10" fill="rgba(200,255,60,.5)"></path>
                  <text x="62" y="120" textAnchor="middle" fontFamily="JetBrains Mono, monospace" fontSize="9" fill="#6E7671">PLAYER</text>
                  <text x="178" y="120" textAnchor="middle" fontFamily="JetBrains Mono, monospace" fontSize="9" fill="#6E7671">COACH</text>
                </svg>
              </div>
            </article>

            <article className="card">
              <span className="card-num">04</span>
              <h3>Memberships</h3>
              <p>Create flexible membership plans and recurring billing.</p>
              <div className="viz">
                <div style={{ position: 'absolute', left: '30px', top: '44px', width: '150px', height: '82px', borderRadius: '10px', background: 'linear-gradient(135deg, #1A1F20, #0F1213)', border: '1px solid rgba(255,255,255,.12)', transform: 'rotate(-7deg)' }}></div>
                <div style={{ position: 'absolute', left: '52px', top: '30px', width: '150px', height: '82px', borderRadius: '10px', background: 'linear-gradient(135deg, #C8FF3C, #9BE000)', transform: 'rotate(5deg)', padding: '12px 14px' }}>
                  <div className="mono" style={{ fontSize: '9px', letterSpacing: '.16em', color: 'rgba(7,8,9,.6)' }}>ALL ACCESS</div>
                  <div className="disp" style={{ fontWeight: '800', fontSize: '17px', color: '#070809', marginTop: '16px' }}>Season Pass</div>
                  <div className="mono" style={{ fontSize: '10px', color: 'rgba(7,8,9,.7)', marginTop: '4px' }}>RENEWS MONTHLY</div>
                </div>
              </div>
            </article>

            <article className="card">
              <span className="card-num">05</span>
              <h3>Admin Panel</h3>
              <p>Manage your entire facility from one powerful dashboard.</p>
              <div className="viz">
                <div style={{ position: 'absolute', inset: '0', display: 'grid', gridTemplateColumns: '52px 1fr' }}>
                  <div style={{ borderRight: '1px solid rgba(255,255,255,.07)', padding: '12px 10px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <span style={{ height: '6px', borderRadius: '3px', background: 'rgba(200,255,60,.8)' }}></span>
                    <span style={{ height: '6px', borderRadius: '3px', background: 'rgba(255,255,255,.12)' }}></span>
                    <span style={{ height: '6px', borderRadius: '3px', background: 'rgba(255,255,255,.12)' }}></span>
                    <span style={{ height: '6px', borderRadius: '3px', background: 'rgba(255,255,255,.12)' }}></span>
                  </div>
                  <div style={{ padding: '12px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <span style={{ flex: '1', height: '30px', borderRadius: '5px', background: 'rgba(255,255,255,.06)' }}></span>
                      <span style={{ flex: '1', height: '30px', borderRadius: '5px', background: 'rgba(255,255,255,.06)' }}></span>
                      <span style={{ flex: '1', height: '30px', borderRadius: '5px', background: 'rgba(76,125,255,.3)' }}></span>
                    </div>
                    <span style={{ height: '8px', width: '70%', borderRadius: '4px', background: 'rgba(255,255,255,.08)' }}></span>
                    <span style={{ height: '8px', width: '90%', borderRadius: '4px', background: 'rgba(255,255,255,.08)' }}></span>
                    <span style={{ height: '8px', width: '55%', borderRadius: '4px', background: 'rgba(255,255,255,.08)' }}></span>
                    <span style={{ height: '8px', width: '80%', borderRadius: '4px', background: 'rgba(255,255,255,.08)' }}></span>
                  </div>
                </div>
              </div>
            </article>

            <article className="card">
              <span className="card-num">06</span>
              <h3>Payments</h3>
              <p>Accept secure online payments without manual work.</p>
              <div className="viz">
                <div style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', width: '168px', borderRadius: '10px', border: '1px solid rgba(255,255,255,.10)', background: '#0F1214', padding: '16px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span style={{ width: '26px', height: '26px', borderRadius: '50%', background: 'rgba(200,255,60,.16)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#C8FF3C" strokeWidth="3" strokeLinecap="round" aria-hidden="true"><path d="M4 12.5 9.5 18 20 6.5"></path></svg>
                    </span>
                    <div>
                      <div className="disp" style={{ fontSize: '14px', fontWeight: '700' }}>Paid</div>
                      <div className="mono" style={{ fontSize: '9.5px', color: 'var(--ink-4)' }}>COURT 04 + RACKET HIRE</div>
                    </div>
                  </div>
                  <div className="rule" style={{ margin: '12px 0' }}></div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                    <span className="mono" style={{ fontSize: '10px', color: 'var(--ink-4)' }}>TOTAL</span>
                    <span className="kpi" style={{ fontSize: '19px' }}>[AMOUNT]</span>
                  </div>
                </div>
              </div>
            </article>

            <article className="card">
              <span className="card-num">07</span>
              <h3>Analytics</h3>
              <p>Turn facility activity into actionable business insights.</p>
              <div className="viz">
                <svg width="100%" height="100%" viewBox="0 0 240 148" fill="none" preserveAspectRatio="none" aria-hidden="true">
                  <defs><linearGradient id="ag" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#C8FF3C" stopOpacity="0.34"></stop><stop offset="100%" stopColor="#C8FF3C" stopOpacity="0"></stop></linearGradient></defs>
                  <path className="chart-fill" d="M0 120 L34 108 L68 112 L102 84 L136 88 L170 54 L204 44 L240 22 L240 148 L0 148 Z" fill="url(#ag)"></path>
                  <path className="chart-line" pathLength="1" d="M0 120 L34 108 L68 112 L102 84 L136 88 L170 54 L204 44 L240 22" stroke="#C8FF3C" strokeWidth="2" strokeLinejoin="round" fill="none"></path>
                </svg>
              </div>
            </article>

            <article className="card">
              <span className="card-num">08</span>
              <h3>Mobile App</h3>
              <p>Give your players a branded experience everywhere.</p>
              <div className="viz">
                <div style={{ position: 'absolute', left: '50%', top: '20px', transform: 'translateX(-50%)', width: '104px', height: '168px', borderRadius: '18px', border: '1.5px solid rgba(255,255,255,.16)', background: 'linear-gradient(180deg, #121617, #0B0E0F)', padding: '14px 10px' }}>
                  <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                    <span style={{ width: '14px', height: '14px', borderRadius: '4px', background: '#C8FF3C' }}></span>
                    <span style={{ height: '5px', width: '42px', borderRadius: '3px', background: 'rgba(255,255,255,.18)' }}></span>
                  </div>
                  <div style={{ height: '40px', borderRadius: '7px', background: 'rgba(200,255,60,.14)', border: '1px solid rgba(200,255,60,.3)', marginTop: '12px' }}></div>
                  <div style={{ height: '26px', borderRadius: '7px', background: 'rgba(255,255,255,.06)', marginTop: '8px' }}></div>
                  <div style={{ height: '26px', borderRadius: '7px', background: 'rgba(255,255,255,.06)', marginTop: '8px' }}></div>
                </div>
              </div>
            </article>
          </div>
        </div>
      </section>

      <div className="rule"></div>
    </>
  );
}
